import api from '../api';
import { API_URL } from '../config';

export const getOffices = async () => {
  try {
    const res = await api.get(`${API_URL}/offices`);
    return res.data;
  } catch (error) {
    console.error('Error fetching offices:', error);
    throw new Error(
      error.response?.data?.error || 
      'Failed to fetch offices. Please try again or contact support.'
    );
  }
};

export const getOfficeById = async (id) => {
  try {
    const res = await api.get(`${API_URL}/offices/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error fetching office:', error);
    throw new Error(
      error.response?.data?.error || 
      'Failed to fetch office. Please try again or contact support.'
    );
  }
};

export const createOffice = async (officeData) => {
  try {
    const res = await api.post(`${API_URL}/offices`, officeData);
    return res.data;
  } catch (error) {
    console.error('Error creating office:', error);
    throw new Error(
      error.response?.data?.error || 
      'Failed to create office. Please try again or contact support.'
    );
  }
};

export const updateOffice = async (id, officeData) => {
  try {
    const res = await api.put(`${API_URL}/offices/${id}`, officeData);
    return res.data;
  } catch (error) {
    console.error('Error updating office:', error);
    throw new Error(
      error.response?.data?.error || 
      'Failed to update office. Please try again or contact support.'
    );
  }
};

export const deleteOffice = async (id) => {
  try {
    const res = await api.delete(`${API_URL}/offices/${id}`);
    return res.data;
  } catch (error) {
    console.error('Error deleting office:', error);
    throw new Error(
      error.response?.data?.error || 
      'Failed to delete office. Please try again or contact support.'
    );
  }
};

export const checkOfficeExists = async (name) => {
  try {
    const res = await api.get(`${API_URL}/offices/exists/${name}`);
    return res.data.exists;
  } catch (error) {
    console.error('Error checking office existence:', error);
    return false;
  }
};